<template>
  <of-page mode="list-form" :leftWidth="300">
    <div slot="leftArea">
      <div class="directory-nav">
        <el-row :gutter="10" class="tree-search">
          <el-col :span="11">
            <el-input
              class="directory-search"
              size="mini"
              placeholder="输入关键字"
              v-model="filterText"
              :disabled="isLoading"
            >
            </el-input>
          </el-col>
          <el-col :span="13" style="text-align: right">
            <div>
              <el-button
                v-access:add
                icon="el-icon-plus"
                size="mini"
                @click="add"
                title="添加根菜单"
                :disabled="isLoading"
                >根菜单
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tree
          :data="directoryList"
          ref="dirTree"
          draggable
          v-loading="isLoading"
          node-key="id"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-drop="handleDragEnd"
          @node-click="selectNode"
        >
          <span class="directory-node" slot-scope="{ node, data }">
            <span class="tree-node-label">{{ data.text }}</span>
            <span class="directory-opear" v-show="currentSelectId === data.id">
              <i
                v-access:add
                v-if="showIcon"
                class="el-icon-plus"
                title="添加目录"
                @click.stop="(n) => append(data, node)"
              ></i>
              <i
                v-access:delete
                class="el-icon-delete"
                title="删除目录"
                @click.stop="(n) => remove(data, node)"
              ></i>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <div slot="toolBar">
      <el-button-group class="btn-oper" v-show="MenuItem.Id">
        <el-button
          v-access:modify
          icon="fa fa-save"
          :disabled="isSave"
          :loading="isSave"
          @click="save"
          size="small"
        >
          保存
        </el-button>
      </el-button-group>
    </div>
    <div slot="content">
      <div
        class="department-detail"
        v-loading="isFormLoading"
        v-show="MenuItem.Id"
      >
        <el-form
          ref="form"
          :model="MenuItem"
          label-width="120px"
          :rules="editFormRules"
        >
          <el-form-item label="菜单名字：" prop="MenuName" class="form-item">
            <el-input v-model="MenuItem.MenuName"></el-input>
          </el-form-item>
          <el-form-item label="PC端链接：" prop="MenuName" class="form-item">
            <el-input v-model="MenuItem.Url"></el-input>
          </el-form-item>
          <el-form-item label="手机端链接：" prop="MenuName" class="form-item">
            <el-input v-model="MenuItem.MobileUrl"></el-input>
          </el-form-item>
          <el-form-item label="封面图：" prop="HeadImage" v-if="MenuItem.ParentId === '75795cc82e30499bbd80ac1700b9a2bc'">
            <p>
              友情提示：只支持.jpg、.png格式，图片大小：宽590像素，高120像素
            </p>
            <of-upload
              class="upload-demo"
              list-type="picture-card"
              @onPreview="onPreview"
              @onRemove="onRemove"
              @onUpLoad="onUpLoad"
              @onExceed="onExceed"
              :limit="1"
              :fileList="pictureList"
              :class="{ hideImg: hideUploadEdit }"
              accept="image/jpeg, image/gif, image/png, image/jpg"
            >
              <div slot="content">
                <i slot="default" class="el-icon-plus"></i>
              </div>
            </of-upload>
            <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
          <el-form-item label="状态" prop="Status">
            <el-radio-group v-model="MenuItem.Status">
              <el-radio :label="0">已启用</el-radio>
              <el-radio :label="1">已禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </of-page>
</template>

<script>
import OfPage from "@/components/base/of_page/of_page";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";

export default {
  name: "dcc-online-dir-list",
  components: {
    OfPage,
    OfUpload
  },
  data() {
    return {
      directoryList: [],
      currentSelectData: {},
      currentSelectId: "",
      isLoading: false,
      isExpand: false,
      filterText: "",
      MenuItem: {},
      activeValue: 1,
      inactiveValue: 0,
      isSave: false,
      isFormLoading: false,
      parentID: "",
      editFormRules: {
        MenuName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      showIcon: true,
      pictureList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      hideUploadEdit: false
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    filterText(val) {
      this.$refs.dirTree.filter(val);
    },
    MenuItem: {
      deep: true,
      handler(nval, oval) {
        if (nval.Level == 2) {
          this.showIcon = false;
        } else {
          this.showIcon = true;
        }
      },
    },
  },
  methods: {
    //删除封面图
    onRemove() {
      (this.pictureList = []), (this.MenuItem.HeadImage = null);
      this.hideUploadEdit = false;
    },
    //查看封面图
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传封面图
    onUpLoad(file) {
      if (file.response.Code === 0) {
        this.MenuItem.HeadImage = '/files'+file.response.Data.StorePath;
        this.$message({
          message: "封面图上传成功",
          type: "success"
        });
        this.hideUploadEdit = true;
      }
    },
    onExceed() {
      this.$message({
        message: `只能选择1个文件`,
        type: "error"
      });
    },
    //初始化封面图
    getImg() {
      if (
        this.MenuItem.HeadImage === undefined ||
        this.MenuItem.HeadImage === null
      ) {

        this.pictureList = []
        this.hideUploadEdit = false
        return false;
      }
      this.hideUploadEdit = true;
      this.$http.get(this.MenuItem.HeadImage).then((res) => {
        let pictureList = [res.config];
        this.pictureList = pictureList.map((item) => {
          return {
            url: item.url,
          };
        });
      });
    },
    loadData() {
      this.isLoading = true;
      api.loadMenuJsTreeNodes().then((rep) => {
        if (rep.data.Code === 0) {
          this.directoryList = rep.data.Data;
          this.getImg()
          window.console.log(this.directoryList);
          
        }
        this.isLoading = false;
      });
    },
    append(data, n) {
      this.isLoading = true;
      this.insertNode(data.id, "新建菜单").then((rep) => {
        this.isLoading = false;
        if (rep.data.Code === 0 && rep.data.Data) {
          const returnData = rep.data.Data;
          if (!n.expanded) {
            n.expanded = true;
          }
          const newChild = {
            id: returnData.Id,
            text: returnData.MenuName,
          };
          if (!data.children) {
            this.$set(data, "children", []);
          }
          data.children.push(newChild);
          this.$message({
            message: "添加成功",
            type: "success",
          });
        } else {
          this.$message({
            message: rep.data.Message,
            type: "error",
          });
        }
      });
    },
    remove(data, node) {
      this.$confirm("确定要删除选中的目录吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isLoading = true;
        let params = { Id: data.id };
        api.DeleteSiteMenu(params).then((rep) => {
          this.isLoading = false;
          if (rep.data.Code === 0) {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex((d) => d.id === data.id);
            children.splice(index, 1);
            this.MenuItem = {};
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    add() {
      this.isLoading = true;
      this.insertNode("", "新建菜单", 0).then((rep) => {
        this.isLoading = false;
        if (rep.data.Code === 0 && rep.data.Data) {
          const returnData = rep.data.Data;
          this.directoryList.push({
            id: returnData.Id,
            text: returnData.MenuName,
            pid: "",
            isEdit: false,
            children: [],
          });
          this.$message({
            message: "添加成功",
            type: "success",
          });
        } else {
          this.$message({
            message: rep.data.Message,
            type: "error",
          });
        }
      });
    },
    insertNode(parentId, nodeName) {
      let params = { Id: parentId, MenuName: nodeName };
      return api.SavenewMenu(params);
    },
    selectNode(data, n) {
      if (!n.expanded) {
        n.expanded = true;
      }
      this.currentSelectData = data;
      this.currentSelectId = data.id;
      this.isFormLoading = true;
      let params = { Id: data.id };
      api.getMenuDir(params).then((rep) => {
        if (rep.data.Code === 0 && rep.data.Data) {
          this.MenuItem = rep.data.Data;
          this.getImg()
        }
        this.isFormLoading = false;
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    handleDragEnd(draggingNode, dropTagerNode, dropType, ev) {
      let ids = [];
      let parentid = "";
      let childrenData = null;
      const id = draggingNode.data.id;
      switch (dropType) {
        case "before":
        case "after":
          parentid = dropTagerNode.parent.data.id || "";
          childrenData =
            dropTagerNode.parent.data.children || dropTagerNode.parent.data;
          childrenData.forEach((x) => {
            ids.push(x.id);
          });
          break;
        case "inner":
          parentid = dropTagerNode.data.id || "";
          childrenData = dropTagerNode.data.children || dropTagerNode.data;
          childrenData.forEach((x) => {
            ids.push(x.id);
          });
          break;
      }
      this.updateMoveNode(id, parentid, ids);
    },
    updateMoveNode(id, pid, ids) {
      this.isLoading = true;
      let params = { id: id, pid: pid, ids: ids.join(",") };
      api.nodeMenuMove(params).then((rep) => {
        this.isLoading = false;
        if (rep.data.Code === 0) {
          this.$message({
            message: "移动节点成功",
            type: "success",
          });
        } else {
          this.$message({
            message: rep.data.Message,
            type: "error",
          });
        }
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isSave = true;
          let params = Object.assign({}, this.MenuItem);
          this.currentSelectData.text = this.MenuItem.MenuName;
          api
            .saveMenuDir(params)
            .then((rep) => {
              this.isSave = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isSave = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    setBoxCardHeight() {
      this.boxCardHeight = window.innerHeight - 160;
      if (this.$refs.leftBoxCard && this.$refs.mainBoxCard) {
        this.$refs.leftBoxCard.$el.style.height = `${this.boxCardHeight}px`;
        this.$refs.mainBoxCard.$el.style.height = `${this.boxCardHeight}px`;
      }
    },
  },
};
</script>

<style scoped>
.department-detail > footer {
  text-align: right;
}

.box-card {
  overflow: auto;
}

.directory-node {
  font-size: 14px;
  padding-right: 8px;
}

.directory-opear {
  position: absolute;
  right: 5px;
}

.directory-opear > i:first-child {
  margin-right: 5px;
}

.directory-search {
  margin-bottom: 10px;
}

.form-item {
  height: 40px;
}

.avatar-uploader >>> .el-upload input[type="file"] {
  display: none !important;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}


</style>
<style>
.hideImg .el-upload--picture-card {
  display: none !important;
}

.hideImg .el-upload--fileList {
  display: none !important;
}
</style>
